import React from "react";
import { Card, Col, Divider, Row, Typography } from "antd";

const { Text } = Typography;

const Preview = ({ formData, templateProdDetail, parentOptions }) => {
  const overview = formData?.overview || {};
  const currencyConfiguration = formData?.currencyConfiguration || {};
  const postingControls = formData?.postingControls || {};
  const balanceManagement = formData?.balanceManagement || {};
  const reconcilationAndControl = formData?.reconcilationAndControl || {};

  console.log(formData, "formData");
  console.log(templateProdDetail, "templateProdDetail");
  const yesNo = (value) => (value === true ? "Yes" : value === false ? "No" : "-");

  const formatValue = (value) => {
    if (value === undefined || value === null || value === "") return "-";
    if (typeof value === "number") return value.toLocaleString();
    if (value?.format) return value.format("YYYY-MM-DD");
    return value;
  };

  const resolveOptionLabel = (options = [], value) => {
    if (value === undefined || value === null || value === "") return "-";
    const match = options.find((option) => option.value === value || option.id === value);
    if (!match) return value;
    return match.label || match.value || match.name || value;
  };

  const currencyOptions = (templateProdDetail?.currencies || []).map((currency) => ({
    value: currency.code,
    label: currency.displayLabel || currency.name || currency.code,
  }));

  const controlAccountFlagOptions = [
    { value: "primary", label: "Primary" },
    { value: "secondary", label: "Secondary" },
    { value: "suspense", label: "Suspense" },
  ];

  const sections = [
    {
      title: "Overview",
      items: [
        { name: "GL Code", value: formatValue(overview.glCode) },
        { name: "Account Name", value: formatValue(overview.name) },
        {
          name: "Short Name",
          value: formatValue(overview.shortName ?? overview.glCode),
        },
        {
          name: "Category",
          value: resolveOptionLabel(parentOptions, overview.parentId),
        },
        {
          name: "Account Level",
          value: resolveOptionLabel(templateProdDetail?.accountLevelOptions, overview.accountLevel),
        },
        {
          name: "Parent",
          value: resolveOptionLabel(parentOptions, overview.parentId),
        },
        {
          name: "Account Status",
          value: resolveOptionLabel(
            templateProdDetail?.accountStatusOptions,
            overview.accountStatus,
          ),
        },
        { name: "Opening Date", value: formatValue(overview.approvedOnDate) },
        { name: "Closing Date", value: formatValue(overview.approvedOnDate) },
        {
          name: "Account Type",
          value: resolveOptionLabel(templateProdDetail?.accountTypeOptions, overview.type),
        },
        {
          name: "Natural Balance",
          value: resolveOptionLabel(
            templateProdDetail?.naturalBalanceOptions,
            overview.naturalBalance,
          ),
        },
        {
          name: "Reporting Code",
          value: formatValue(overview.glCode),
        },
        {
          name: "IFRS Classification",
          value: resolveOptionLabel(
            templateProdDetail?.ifrsClassificationOptions,
            overview.ifrsClassification,
          ),
        },
        {
          name: "Tax Category",
          value: resolveOptionLabel(templateProdDetail?.taxCategoryOptions, overview.taxCategory),
        },
      ],
    },
    {
      title: "Currency Configuration",
      items: [
        {
          name: "Currency Code",
          value: resolveOptionLabel(currencyOptions, currencyConfiguration.currencyCode),
        },
        {
          name: "Multi Currency Allowed",
          value: yesNo(currencyConfiguration.multiCurrencyAllowed),
        },
        {
          name: "Revaluation Required",
          value: yesNo(currencyConfiguration.revaluationRequired),
        },
        {
          name: "Revaluation GL Account",
          value: resolveOptionLabel(
            templateProdDetail?.parentAccountOptions,
            currencyConfiguration.revaluationGlAccountId,
          ),
        },
      ],
    },
    {
      title: "Posting Controls",
      items: [
        { name: "Posting Allowed", value: yesNo(postingControls.postingAllowed) },
        { name: "Debit Allowed", value: yesNo(postingControls.debitAllowed) },
        { name: "Credit Allowed", value: yesNo(postingControls.creditAllowed) },
        {
          name: "Maximum Transaction Limit",
          value: formatValue(postingControls.maxTransactionLimit),
        },
        {
          name: "Batch Posting Allowed",
          value: yesNo(postingControls.batchPostingAllowed),
        },
      ],
    },
    {
      title: "Balance Management",
      items: [
        {
          name: "Opening Balance",
          value: formatValue(balanceManagement.openingBalance),
        },
        {
          name: "Minimum Balance Allowed",
          value: formatValue(balanceManagement.minimumBalanceAllowed),
        },
        {
          name: "Maximum Balance Allowed",
          value: formatValue(balanceManagement.maximumBalanceAllowed),
        },
        {
          name: "Overdraft Allowed",
          value: yesNo(balanceManagement.overdraftAllowed),
        },
      ],
    },
    {
      title: "Reconciliation & Control",
      items: [
        {
          name: "Control Account Flag",
          value: resolveOptionLabel(
            controlAccountFlagOptions,
            reconcilationAndControl.controlAccountFlag,
          ),
        },
        {
          name: "Reconcilation Required",
          value: yesNo(reconcilationAndControl.reconcilationRequired),
        },
        {
          name: "External Reconciliation Code",
          value: formatValue(reconcilationAndControl.externalReconciliationCode),
        },
        {
          name: "Settlement Flag",
          value: formatValue(reconcilationAndControl.settlementFlag),
        },
      ],
    },
  ];

  const renderSection = (title, items) => (
    <div
      style={{
        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
        marginBottom: 25,
      }}
    >
      <Divider orientation="left" orientationMargin="0">
        {title}
      </Divider>
      {items.map((detail, index) => {
        const { name, value } = detail;

        return (
          <div
            style={{
              border: "2px solid #F5F5F5",
              borderRadius: 15,
              borderBottomLeftRadius: 0,
              borderBottomRightRadius: 0,
              borderBottomColor: "#E2E2E2",
            }}
            key={`${title}-${index}`}
          >
            <Row>
              <Col
                span={12}
                style={{
                  backgroundColor: "#F5F5F5",
                  padding: 10,
                  borderRadius: 15,
                  borderTopRightRadius: 0,
                  borderBottomRightRadius: 0,
                  borderBottomLeftRadius: 0,
                }}
              >
                <Text strong>{name}</Text>
              </Col>
              <Col
                span={12}
                style={{
                  padding: 10,
                }}
              >
                <Text className="of-bold-disable-input">{value}</Text>
              </Col>
            </Row>
          </div>
        );
      })}
    </div>
  );

  return (
    <Card
      style={{
        marginBottom: "2%",
        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
      }}
    >
      {sections.map((section) => renderSection(section.title, section.items))}
    </Card>
  );
};

export default Preview;
